import React from 'react';
import './App.css';
import LandingPage from './views/LandingPage/index';
import { ThemeProvider } from 'styled-components'
import { light, dark } from '@pancakeswap/uikit'
import { Paper } from '@mui/material';
import { Route, Routes } from 'react-router-dom';
import CommonHeader from 'components/PageHeader/CommonHeader';
import Farms from 'views/Farms';
import Pools from 'views/Pools';
import SideBar from 'views/SideBar';
import Home from 'views/Home';
window.Buffer = window.Buffer || require("buffer").Buffer;


function App() {
  return (
    <Paper sx={{ backgroundColor: '#000B22', minHeight: '100vh' }}>
      <ThemeProvider theme={light}>
        {/* <CommonHeader></CommonHeader> */}
        {/* <SideBar></SideBar> */}
        <Routes>
          {/* <Route path='/' element={<LandingPage />} />
          <Route path='/pool' element={<Pools />} />
          <Route path='/farm' element={<Farms />} /> */}

          {/* <Route path='/*' element{<Home />} /> */}
          <Route path='/*' element={<Home />} />
        </Routes>

      </ThemeProvider>
    </Paper>
  );
}

export default App;
